export class CompatibiliteMessage {
    constructor() {}
  
    titlecompatibilite = 'modal.titlecompatibilite';
    M09 = 'modal.M09';
    M010 = 'modal.M010';
    M037 = 'modal.M037';
    M038 = 'modal.M038';
    M013 = 'modal.M013';
    M016 = 'modal.M016';
    M018 = 'modal.M018';
    M026 = 'modal.M026';
    M042 = 'modal.M042';
    M043 = 'modal.M043';
    MOD2 = 'modal.mod2';
  }
  
